import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface IMarkdownProps {
  children: string
  /**
   * @default 'Loading...'
   */
  loadingText?: string
}

export const Markdown = ({ children, loadingText = 'Loading ...' }: IMarkdownProps) => {
  return <ReactMarkdown remarkPlugins={[remarkGfm]}>{children || loadingText}</ReactMarkdown>
}
